import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { getOpeningTimes } from '../../../api';

const OpenIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="3" fill="#4D8661" />
    <circle
      cx="5"
      cy="5"
      r="4"
      stroke="#4D8661"
      strokeOpacity="0.4"
      strokeWidth="2"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="3" fill="#A6423E" />
    <circle
      cx="5"
      cy="5"
      r="4"
      stroke="#A6423E"
      strokeOpacity="0.2"
      strokeWidth="2"
    />
  </svg>
);

const OpeningTimes = ({ id, customerSuite }) => {
  const [showOpeningTimes, setShowOpeningTimes] = useState(false);
  const [openingTimesArr, setOpeningTimesArr] = useState([]);
  const [developmentIsOpen, setDevelopmentIsOpen] = useState(false);

  useEffect(() => {
    getOpeningTimes(id).then((data) => {
      if (data) {
        setOpeningTimesArr(data.data);
      }
    });
  }, []);

  useEffect(() => {
    if (openingTimesArr.length > 0) {
      const currentDay = moment().format('d');
      const today = openingTimesArr.find(
        (day) => day.opening_times.day.value === currentDay
      );

      if (today) {
        const currentHour = moment().format('HH:mm');
        if (today.opening_times.opens_at && today.opening_times.closes_at) {
          setShowOpeningTimes(true);
        }

        if (
          moment(currentHour, 'HH:mm').isBetween(
            moment(today.opening_times.opens_at, 'HH:mm'),
            moment(today.opening_times.closes_at, 'HH:mm')
          )
        ) {
          setDevelopmentIsOpen(true);
        } else {
          setDevelopmentIsOpen(false);
        }
      }
    }
  }, [openingTimesArr, id]);

  if (!openingTimesArr || !showOpeningTimes) return <div />;

  return (
    <div className="card-opening-times">
      {developmentIsOpen ? (
        <span className="card-opening-times__status">
          <OpenIcon /> {customerSuite} Open
        </span>
      ) : (
        <span className="card-opening-times__status">
          <CloseIcon />  {customerSuite} Closed
        </span>
      )}
    </div>
  );
};

export default OpeningTimes;
